<template>
  <div class="status-list scroll-styling rounded-lg ">

    <!-- Course Detail Modal (with info before application) -->
    <CourseDetailModal
      v-if="showCourseDetail && courseUUID"
      :courseUUID="courseUUID"
      :onClose="closeCourseDetail"
      :onSubmit="openApplicationModal"
    />

    <!-- Application Form Modal -->
    <SubmitApplicationModal
      v-if="showApplicationModal && courseUUID"
      :modalClose="modalClose"
      :uuid="courseUUID"
    />

    <div v-if="showSuggestForm && user.role && user.role.key === 2" class="fixed inset-0 bg-black bg-opacity-50 z-[10010] flex items-center justify-center p-4">
      <div class="bg-white rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div class="sticky top-0 bg-white border-b p-6 flex justify-between items-center">
          <h2 class="text-2xl font-bold text-gray-900">
            Предложить курс
          </h2>
          <button
            @click="showSuggestForm = false"
            class="text-gray-500 hover:text-gray-700 text-2xl"
          >
            ✕
          </button>
        </div>

        <div class="p-6">
          <CourseSuggestForm
            @submit="handleSuggestSubmit"
            @close="showSuggestForm = false"
          />
        </div>
      </div>
    </div>

    <!-- Button: Suggest Course (only for Expert role=2) -->
    <div v-if="isAuthenticated && (user.role && user.role.key === 2)" class="mb-6 flex">
      <button
        @click="showSuggestForm = true"
        class="px-4 md:px-6 py-2 bg-gray-800 text-white rounded-xl hover:bg-gray-700 transition font-medium text-xs md:text-sm whitespace-nowrap"
      >
        <b>Предложить курс</b>
      </button>
    </div>

    <div class="relative overflow-x-auto">
      <table 
        class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
      >
        <thead
          class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
        >
          <tr>
            <th scope="col" class="px-6 py-3">#</th>
            <th scope="col" class="px-6 py-3">Курс</th>
            <th
              v-if="user.role && user.role.key === 1"
              scope="col" class="px-6 py-3">Действий</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(el, ind) in courses"
            :key="ind"
            class="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
          >
            <td class="px-6 py-4">{{ ind + 1 }}</td>
            <td class="px-6 py-4">{{ el.title }}</td>
            <td
              v-if="user.role && user.role.key === 1"
              class="px-6 py-4">
              <button
                v-if="!el.status"
                @click="openModal(el.uuid)"
                style="font-size: 12px"
                class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
              >
                Оставить заявку
              </button>
              <div
                v-else-if="(el.blocked || el.status === 'Не одобрили') && el.attempts_used < el.max_attempts"
              >
                <p class="text-red-600 text-xs font-semibold mb-2">
                  Доступ к курсу заблокирован. Оставьте повторную заявку. У вас осталось {{ el.max_attempts - el.attempts_used }} попыток для повторного прохождения курса. Возможно потребуется повторная оплата курса — обратитесь к модератору за уточнением деталей.
                </p>
                <button
                  @click="openModal(el.uuid)"
                  style="font-size: 12px"
                  class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                >
                  Оставить заявку повторно
                </button>
              </div>
              <div v-else-if="(el.blocked || el.status === 'Не одобрили') && el.attempts_used >= el.max_attempts">
                <p class="text-red-600 font-bold text-sm">Попытки исчерпаны ({{ el.attempts_used }} из {{ el.max_attempts }})</p>
                <p class="text-gray-600 text-sm mt-1">Свяжитесь с модератором для сброса попыток и уточнения условий повторного прохождения.</p>
              </div>
              <p v-else>Заявка - {{ el.status }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_CLIENT, HEADERS_TOKEN_JSON } from "@/const/uri";
import SubmitApplicationModal from "@/components/Client/modals/SubmitApplication.vue";
import CourseDetailModal from "@/components/Client/modals/CourseDetailModal.vue";
import CourseSuggestForm from "@/components/Course/CourseSuggestForm.vue";
import { mapState } from "vuex";

export default {
  components: {
    SubmitApplicationModal,
    CourseDetailModal,
    CourseSuggestForm,
  },
  data() {
    return {
      clientToken: null,
      courses: [],
      courseUUID: null,
      showCourseDetail: false,
      showApplicationModal: false,
      showSuggestForm: false,
      isAuthenticated: false,
    };
  },
  mounted() {
    this.checkAuthentication();
    this.loadData();
    if (this.$route.query.courseUUID) {
      this.courseUUID = this.$route.query.courseUUID;
      // If showApplication=true, open application form directly (from course detail page)
      // Otherwise, show course detail modal first (from courses list)
      if (this.$route.query.showApplication === 'true') {
        this.showApplicationModal = true;
      } else {
        this.showCourseDetail = true;
      }
    }
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    checkAuthentication() {
      const token = localStorage.getItem('user_token');
      this.isAuthenticated = !!token;
    },
    openModal(uuid) {
      this.courseUUID = uuid;
      this.showCourseDetail = true;
      this.$router.push({
        query: { courseUUID: uuid }
      });
    },
    closeCourseDetail() {
      this.showCourseDetail = false;
      this.courseUUID = null;
      this.$router.push({
        query: {}
      });
    },
    openApplicationModal() {
      this.showCourseDetail = false;
      this.showApplicationModal = true;
    },
    modalClose() {
        this.showApplicationModal = false;
        this.courseUUID = null;
        this.$router.push({
          query: {}
        });
    },
    handleSuggestSubmit() {
      this.showSuggestForm = false;
      this.loadData();
    },
    async loadData() {
      await axios({
        method: "GET",
        url: API_CLIENT.course,
        data: {},
        headers: HEADERS_TOKEN_JSON(),
      })
        .then((e) => {
          this.courses = e.data.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  props: {},
};
</script>